import React from 'react';
import { PassportLogin } from '@jd/x-coreui';
import './login.scss';

const Login = () => {
  return (
    <div className='login-container'>
      <div className='login-car-box'></div>
      <div className='login-title'></div>
      <div className='login-tab-box'>
        <PassportLogin
          returnUrl={`${window.location.protocol}//${process.env.JDX_APP_JDX_MONITOR}`}
        />
      </div>
    </div>
  );
};
export default Login;
